import { Reveal } from "@/components/Reveal";

const Label = ({ children }) => (
  <span className="text-xs font-semibold uppercase tracking-[0.16em] text-[var(--ember)]">
    {children}
  </span>
);

const REASONS = [
  { n: "01", t: "Revenue, not views", d: "We optimize for leads, pipeline, and payback — the numbers that actually hit your account, not vanity metrics." },
  { n: "02", t: "Proven formulas, not guesswork", d: "Every plan is validated against frameworks that already win, so we're building on evidence from day one." },
  { n: "03", t: "A named human is accountable", d: "Real oversight at every tier — a person who directs the work, reviews it, and answers for the result. That's AI Standards." },
  { n: "04", t: "We adapt as fast as the platforms do", d: "Algorithms and formats change constantly; the team tracks them so your plan never goes stale." },
  { n: "05", t: "You own everything we build", d: "No lock-in by dependency. The assets, the funnel, the CRM setup — all yours." },
  { n: "06", t: "Vertical-built", d: "Your playbook is tuned to your industry, not a generic one-size-fits-all template." },
];

export const WhyUs = () => (
  <section id="why-us" className="scroll-mt-24 bg-[var(--bg-contrast)] py-28 md:py-36" data-testid="growth-why-us">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <div className="max-w-2xl">
        <Reveal><Label>Why us</Label></Reveal>
        <Reveal delay={80}><h2 className="mt-7 t-section">Six reasons clients stay.</h2></Reveal>
        <Reveal delay={140}>
          <p className="mt-6 text-base leading-relaxed text-[var(--muted)] sm:text-lg">
            Anyone can win a first month. Here's why the relationship compounds instead of churning.
          </p>
        </Reveal>
      </div>
      <ol className="mt-14 grid gap-x-10 gap-y-10 sm:grid-cols-2 lg:grid-cols-3">
        {REASONS.map((r) => (
          <Reveal key={r.n}>
            <li className="border-t border-black/10 pt-5">
              <span className="text-2xl font-semibold tracking-[-0.03em] text-[var(--ember)]/40">{r.n}</span>
              <h3 className="mt-3 text-lg font-semibold tracking-[-0.02em] text-[var(--ink)]">{r.t}</h3>
              <p className="mt-2 text-[15px] leading-relaxed text-[var(--muted)]">{r.d}</p>
            </li>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
